import React, { useRef, PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { gql } from '@yi/core';
import { i18n_article_pose_anatomy } from '@yi/i18n/phrases/i18n_article_pose_anatomy';
import { i18n_article_pose_category } from '@yi/i18n/phrases/i18n_article_pose_category';
import { i18n_article_pose_pronunciation } from '@yi/i18n/phrases/i18n_article_pose_pronunciation';

import { IconAudio, useLocale } from '~/components';
import { turquoise } from '~/styles';

interface Props {
  pose: gql.typesSsr.Query_Pose_yi_Pose;
}

export const PoseCategorySection: React.FC<PropsWithChildren<Props>> = ({
  pose: { pose_type, pose_category, pose_pronunciation_text, pose_pronunciation_audio_url },
}) => {
  const { locale } = useLocale();
  const audioRef = useRef<HTMLAudioElement>(null);
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Box mb={2}>
            <p style={{ lineHeight: 1, margin: 0, overflowWrap: 'normal' }}>
              <small>
                <strong>{i18n_article_pose_category(locale)}</strong>
              </small>
            </p>
            <p style={{ margin: 0 }}>{pose_category.map(t => t.name).join(', ')}</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box mb={2}>
            <p style={{ lineHeight: 1, margin: 0, overflowWrap: 'normal' }}>
              <small>
                <strong>{i18n_article_pose_anatomy(locale)}</strong>
              </small>
            </p>
            <p style={{ margin: 0 }}>{pose_type.map(t => t.name).join(', ')}</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box mb={2}>
            <p style={{ lineHeight: 1, margin: 0 }}>
              <small>
                <strong>{i18n_article_pose_pronunciation(locale)}</strong>
              </small>
            </p>
            <p style={{ margin: 0 }}>
              <a
                href="javascript:void(0)"
                onClick={() => audioRef.current?.play()}
                style={{ color: turquoise }}
              >
                <IconAudio /> {pose_pronunciation_text}
              </a>
            </p>
            <audio ref={audioRef} src={pose_pronunciation_audio_url} />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
